import React from "react";
import {
  FaTools,
  FaLightbulb,
  FaHandshake,
  FaUsers,
} from "react-icons/fa";
import "./teamSection.css";

interface Member {
  name: string;
  role: string;
  image?: string;
  icon?: string;
}

interface TeamSectionProps {
    id?: string;    
  title: string;
  subtitle?: string;
  members: Member[];
}

export const TeamSection: React.FC<TeamSectionProps> = ({
  title,
  subtitle,
  members,
}) => {
  const iconMap: Record<string, any> = {
    FaTools,
    FaLightbulb,
    FaHandshake,
    FaUsers,
  };
  const getIcon = (name?: string) => {
    if (!name) return null;
    const IconComponent = iconMap[name];
    if (!IconComponent) return null;
    return <IconComponent className="member-icon" />;
  };

  return (
    <div className="team-mosaic-section">
      <h2 className="team-title">{title}</h2>
      {subtitle && <p className="team-subtitle">{subtitle}</p>}

      <div className="mosaic-container">
        {members.map((member, idx) => (
          <div key={idx} className="mosaic-member">
            <div className="member-image-wrapper">
              <div className="member-image-ring">
                {member.icon ? (
                  <div className="member-image member-icon-wrapper">
                    {getIcon(member.icon)}
                  </div>
                ) : member.image ? (
                  <img src={member.image} alt={member.name} className="member-image" />
                ) : (
                  <div className="member-image member-placeholder">Image</div>
                )}
              </div>
              <div className="member-info">
                <h4>{member.name}</h4>
                <p>{member.role}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
